var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container container-fluid"},[_c('Layout',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('RouterView')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }